import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { ConnectivityFetcher3s7vafe801t1v as ConnectivityFetcher } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/networking/ConnectivityFetcher.mjs';
import { BulkFetcher2m111bjvjns8 as BulkFetcher } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/networking/BulkFetcher.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { LiveApij3dypzwiy6xu as LiveApi } from './LiveApi.mjs';
import { getDefaultServerBackend23eva9cd76aqs as getDefaultServerBackend } from './apiOptions.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_selectedApi() {
  _init_properties_apiOptions_kt__lelycc();
  return selectedApi;
}
var selectedApi;
function get_apiOverride() {
  _init_properties_apiOptions_kt__lelycc();
  return apiOverride;
}
var apiOverride;
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function ApiOption$Companion$_anonymous__1rx49s() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.sdk.ApiOption', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  ApiOption_Production_instance = new (ApiOption())('Production', 0, ' ', 'https://api.thecommunitygroupinc.org', 'wss://api.thecommunitygroupinc.org');
  ApiOption_Staging_instance = new (ApiOption())('Staging', 1, 'Staging', 'https://staging.api.thecommunitygroupinc.org', 'wss://staging.api.thecommunitygroupinc.org');
  ApiOption_Dev_instance = new (ApiOption())('Dev', 2, 'Dev', 'https://api.tcg.cs.lightningkite.com', 'wss://ws.api.tcg.cs.lightningkite.com');
  ApiOption_SameServer_instance = new (ApiOption())('SameServer', 3, 'Same Server', '/api', '/api');
  ApiOption_Local_instance = new (ApiOption())('Local', 4, 'Local', 'http://localhost:8080', 'ws://localhost:8080');
  if (Companion_instance_0 === VOID) {
    Companion_instance;
    new (Companion())();
  }
}
var ApiOption_Production_instance;
var ApiOption_Staging_instance;
var ApiOption_Dev_instance;
var ApiOption_SameServer_instance;
var ApiOption_Local_instance;
function values() {
  static_init();
  return [ApiOption_Production_getInstance(), ApiOption_Staging_getInstance(), ApiOption_Dev_getInstance(), ApiOption_SameServer_getInstance(), ApiOption_Local_getInstance()];
}
function get_entries() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, ApiOption$Companion$_anonymous__1rx49s);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  static_init();
  return Companion_instance_0;
}
var $ENTRIES;
var ApiOptionClass;
function ApiOption() {
  if (ApiOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, apiName, http, ws) {
        super(name, ordinal);
        this.apiName_1 = apiName;
        this.http_1 = http;
        this.ws_1 = ws;
      }
      get_baseFetcher_yzjfyr_k$() {
        var tmp;
        if (setOf(ApiOption_Dev_getInstance()).contains_aljjnj_k$(this)) {
          var tmp_0 = this.http_1 + '/meta/bulk';
          var tmp_1 = this.ws_1 + '?path=/multiplex';
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          var tmp$ret$0 = toDuration(30, DurationUnit_SECONDS_getInstance());
          tmp = new (BulkFetcher())(tmp_0, tmp_1, VOID, tmp$ret$0);
        } else {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          var tmp$ret$1 = toDuration(30, DurationUnit_SECONDS_getInstance());
          tmp = new (ConnectivityFetcher())(this.http_1, this.ws_1, VOID, tmp$ret$1);
        }
        return tmp;
      }
      get_api_18j9e7_k$() {
        return new (LiveApi())(this.get_baseFetcher_yzjfyr_k$());
      }
    }
    initMetadataForClass($, 'ApiOption', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    ApiOptionClass = $;
  }
  return ApiOptionClass;
}
function ApiOption_Production_getInstance() {
  static_init();
  return ApiOption_Production_instance;
}
function ApiOption_Staging_getInstance() {
  static_init();
  return ApiOption_Staging_instance;
}
function ApiOption_Dev_getInstance() {
  static_init();
  return ApiOption_Dev_instance;
}
function ApiOption_SameServer_getInstance() {
  static_init();
  return ApiOption_SameServer_instance;
}
function ApiOption_Local_getInstance() {
  static_init();
  return ApiOption_Local_instance;
}
var properties_initialized_apiOptions_kt_513xx6;
function _init_properties_apiOptions_kt__lelycc() {
  if (!properties_initialized_apiOptions_kt_513xx6) {
    properties_initialized_apiOptions_kt_513xx6 = true;
    var tmp0 = 'apiOption';
    // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
    var defaultValue = getDefaultServerBackend();
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(getKClass(ApiOption()), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
    selectedApi = PersistentProperty().new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$(tmp0, defaultValue, tmp$ret$1);
    apiOverride = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
  }
}
//region block: exports
export {
  ApiOption_Dev_getInstance as ApiOption_Dev_getInstance95677x1au46r,
  ApiOption_Local_getInstance as ApiOption_Local_getInstance3qz3xgeh0kmmi,
  ApiOption_Production_getInstance as ApiOption_Production_getInstanceubmglnekim4q,
  ApiOption_SameServer_getInstance as ApiOption_SameServer_getInstance2ipdc4gluvj3e,
  ApiOption_Staging_getInstance as ApiOption_Staging_getInstanceh0ucumoveaak,
  get_entries as get_entrieswc88194blsbo,
  get_apiOverride as get_apiOverride256dzuooesqle,
  get_selectedApi as get_selectedApi2lg32khtf3h6e,
};
//endregion

//# sourceMappingURL=apiOptions.mjs.map
